// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_b2-0";
export var orangeButton = "_b2-1";